<template>
 	<b-container fluid>
        <b-row class="page-title">
            <b-container fluid>
                <b-row>
                    <b-col>
                        <h3>Bills</h3>
                    </b-col>
                    <b-col class="buttons-create text-right">
                        <b-button v-if="$can('create-bills') || $can('view-all')" variant="outline-primary" size="sm" to="/purchasing/bills/create">New Bill</b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('modal-common-export-columns')">Export</b-button>
                        <b-button variant="outline-primary" size="sm" @click="exportLineItemsExcel">
                            <span v-if="exports.loading">
                                <b-spinner class="align-middle"></b-spinner>
                                <strong>Exporting Line Items...</strong>
                            </span>
                            <span v-else>Export Line Items</span>
                        </b-button>
                        <b-button variant="outline-primary" size="sm" @click="openModal('modal-common-adjust-columns')"><i class="fas fa-columns"></i></b-button>
                    </b-col>
                </b-row>
                <hr>
            </b-container>
        </b-row>

        <b-row>
            <b-container fluid>
                <b-row>
                    <b-col cols="3">
                        <b-form-group>
                          <b-input-group size="sm">
                            <b-form-input
                              v-model="tables.bills.filter"
                              type="search"
                              id="filterInput"
                              placeholder="Type to Search"
                              debounce="500"
                            ></b-form-input>
                            <b-input-group-append>
                              <b-button :disabled="!tables.bills.filter && !filters.selected.vendors.length && !filters.selected.status.length && !filters.selected.tags.length" @click="clearFilters">Clear</b-button>
                            </b-input-group-append>
                          </b-input-group>
                        </b-form-group>
                    </b-col>

                    <b-col cols="2">
                        <treeselect
                            name="filtersStatusSelect"
                            class="filters-status-select"
                            clearable
                            :searchable="false"
                            open-on-click
                            clear-on-select
                            close-on-select
                            disableBranchNodes
                            placeholder="Status"
                            :options="filters.status"
                            @input="filterSelect($event, 'status')"
                            :value="filters.selected.status"
                            multiple
                            ref="selectStatus"
                            />
                    </b-col>

                    <b-col cols="2">
                        <treeselect
                            name="filtersVendorsSelect"
                            class="filters-vendors"
                            clearable
                            :searchable="false"
                            open-on-click
                            clear-on-select
                            close-on-select
                            disableBranchNodes
                            placeholder="Vendors"
                            :options="filters.vendors"
                            @input="filterSelect($event, 'vendors')"
                            multiple
                            ref="selectVendors"
                            />
                    </b-col>

                    <b-col cols="2">
                        <treeselect
                            name="filtersTags"
                            class="filters-tags"
                            clearable
                            :searchable="false"
                            open-on-click
                            clear-on-select
                            close-on-select
                            disableBranchNodes
                            placeholder="Tags"
                            :options="filters.tags"
                            @input="filterSelect($event, 'tags')"
                            multiple
                            ref="selectTags"
                            />
                    </b-col>

                    <b-col cols="2" />

                    <b-col cols="1">
                        <b-form-group>
                          <b-form-select
                            v-model="tables.bills.perPage"
                            id="perPageSelect"
                            size="sm"
                            :options="tables.bills.pageOptions"
                          ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b-row class="row-bills-table">
                    <b-container fluid>
                        <b-table
                            v-if="tables.bills.ready"
                            :key="tables.bills.key"
                            class="bills-table"
                            responsive bordered striped
                            hover no-border-collapse
                            sticky-header="calc(100vh - 250px)"
                            head-variant="light"
                            :items="tables.bills.items"
                            :fields="visibleFields"
                            :sort-by="tables.bills.sortBy"
                            :sort-desc="tables.bills.sortDesc"
                            :per-page="tables.bills.perPage"
                            :current-page="tables.bills.currentPage"
                            :filter="tables.bills.filter"
                            @filtered="onFiltered"
                            :busy="tables.bills.isBusy"
                        >

                            <template v-slot:table-busy>
                                <div class="text-center text-default my-2">
                                    <b-spinner class="align-middle"></b-spinner>
                                    <strong>Loading...</strong>
                                </div>
                            </template>

                            <template v-slot:cell(id)="row">
                                <b-link v-if="$can('view-bills-details') || $can('view-all')" :to="{name: 'BillsDetail', params: { billNum: row.item.source_bill_number, vendorName: row.item.vendor.name } }">{{ row.item.id }}</b-link>
                                <span v-else>{{ row.item.source_bill_number }}</span>
                            </template>

                            <template v-slot:cell(vendor)="row">
                                <b-link :to="{name: 'VendorDetail', params: { id: row.item.vendor.id } }">{{ row.item.vendor.name }}</b-link>
                            </template>

                            <template v-slot:cell(source_bill_number)="row">
                                <b-link v-if="$can('view-bills-details') || $can('view-all')" :to="{name: 'BillsDetail', params: { billNum: row.item.source_bill_number, vendorName: row.item.vendor.name } }">{{ row.item.source_bill_number }}</b-link>
                                <span v-else>{{ row.item.source_bill_number }}</span>
                            </template>

                            <template v-slot:cell(total)="row">
                                <span>$ {{ numberWithCommas(row.item.total) || '0.00' }}</span>
                            </template>

                            <template v-slot:cell(bill_tag)="row">
                                <span v-if="row.item.bill_tag">
                                    <b-badge v-for="(tag, index) in row.item.bill_tag" :key="index" pill variant="secondary" class="tag-badges">{{ tag.orders_tag.name }}</b-badge>
                                </span>
                                <span v-else></span>
                            </template>

                            <template v-slot:cell(actions)="row">
                                <b-container class="actions-icons" fluid>
                                    <b-row>
                                        <!-- <b-col>
                                            <b-link @click="openModal('listing', row.item, 'edit')"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <b-col>
                                            <b-link @click="showMsgBoxDeleteConfirm('invoices', row.item)" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                        <!-- <b-col>
                                            <b-link @click=""><i class="far fa-check-square"></i></b-link>
                                        </b-col> -->
                                        <b-col>
                                            <b-link v-if="$can('view-bills-details') || $can('view-all')" :to="{name: 'BillsDetail', params: { billNum: row.item.source_bill_number, vendorName: row.item.vendor.name } }"><i class="fas fa-edit"></i></b-link>
                                        </b-col>
                                        <!-- <b-col>
                                            <b-link @click="" class="icon-danger"><i class="fas fa-trash-alt"></i></b-link>
                                        </b-col> -->
                                    </b-row>
                                </b-container>
                            </template>
                        </b-table>
                    </b-container>
                </b-row>

                <b-row>
                    <b-col cols="6">
                        {{ pageTotals }}
                    </b-col>

                    <b-col cols="6" class="my-1">
                        <b-pagination
                          v-model="tables.bills.currentPage"
                          :total-rows="tables.bills.totalRows"
                          :per-page="tables.bills.perPage"
                          align="fill"
                          size="sm"
                          class="my-0"
                        ></b-pagination>
                    </b-col>
                </b-row>

                <modal-adjust-columns
                    v-if="modals['modal-common-adjust-columns'].active"
                    :fields="modals['modal-common-adjust-columns'].fields"
                    @saveColSaves="saveColSaves"
                />

                <modal-export-columns
                    v-if="modals['modal-common-export-columns'].active"
                    :fields="modals['modal-common-export-columns'].fields"
                    :ignores="modals['modal-common-export-columns'].ignores"
                    @exportExcel="exportExcel"
                />
            </b-container>
        </b-row>
    </b-container>
</template>

<script>
    import Treeselect from '@riophae/vue-treeselect'
    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import ModalAdjustColumns from '../../common/modals/AdjustColumns'
    import ModalExportColumns from '../../common/modals/ExportColumns'
 	export default {
    	name: 'Bills',

        metaInfo() {
            return {
                title: 'Bills',
            }
        },

    	components: {
      		Treeselect,
            'modal-adjust-columns': ModalAdjustColumns,
            'modal-export-columns': ModalExportColumns
    	},
        data() {
            return {
                modals: {
                    'modal-common-adjust-columns': {
                        active: 0,
                        fields: []
                    },

                    'modal-common-export-columns': {
                        active: 0,
                        fields: [],
                        ignores: ['actions']
                    },
                },
                tables: {
                    bills: {
                        filteredItems: [],
                        isBusy: false,
                        totalRows: 1,
                        currentPage: 1,
                        perPage: 20,
                        pageOptions: [20, 50, 100, 500, 1000],
                        sortBy: 'id',
                        sortDesc: true,
                        // sortDirection: 'asc',
                        filter: null,
                        key: 1,
                        userfields: [],
                        fields: [
                            {
                                key: 'id',
                                label: 'ID',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'date',
                                label: 'Date Placed',
                                sortable: true,
                                thClass: 'bills-table-style-datetime',
                                visible: 1
                            },
                            {
                                key: 'last_shipment',
                                label: 'Last Shipment',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'vendor',
                                label: 'Vendor',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'source_bill_number',
                                label: 'PO #',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'status',
                                label: 'Status',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'total',
                                label: 'Total',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'percentage_filled',
                                label: 'Percentage Filled',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'bill_tag',
                                label: 'Tags',
                                sortable: true,
                                visible: 1
                            },
                            {
                                key: 'actions',
                                label: '',
                                thClass: 'bills-table-style-actions',
                                visible: 1
                            }
                        ],

                        items: [],
                        categories: [],
                        ready: 0
                    },
                },

                filters: {
                    selected: {
                        status: [],
                        vendors: [],
                        tags: []
                    },
                    status: [
                        {
                            id: 'Pending',
                            label:'Pending'
                        },
                        {
                            id: 'Confirmed',
                            label:'Confirmed'
                        },
                        {
                            id: 'Received',
                            label:'Received'
                        },
                        {
                            id: 'Cancelled',
                            label:'Cancelled'
                        }
                    ],
                    vendors: [],
                    tags: []
                },

                exports: {
                    cols: [],
                    loading: false
                }
            }
        },
        methods: {
            exportExcel(cols, keys) {
                let url = 'api/exports/generateexport'
                axios.post(url, {
                    rows: this.objFilter(this.tables.bills.filteredItems, keys),
                    table: 'bills',
                    cols: cols,
                    keys: keys
                },
                {
                    responseType: 'blob'
                })
                .then((res) => {
                    this.forceFileDownload(res)
                }, () => {
                    this.has_error = true
                })
            },

            exportLineItemsExcel() {
                this.exports.loading = true
                let url = 'api/purchasing/bills/exportlineitems'
                axios.post(url, {
                    rows: this.tables.bills.filteredItems
                },
                    {
                        responseType: 'blob'
                    })
                    .then((res) => {
                        this.forceFileDownload(res)
                        this.exports.loading = false
                    }, () => {
                        this.has_error = true
                    })
            },

            forceFileDownload(response){
                const url = window.URL.createObjectURL(new Blob([response.data]))
                const link = document.createElement('a')
                link.href = url
                link.setAttribute('download', 'Bills_Export_File_' + +new Date() + '.xlsx') //or any other extension
                document.body.appendChild(link)
                link.click()

                this.showAlertBox('success', 'File Generated', 'Bills export file generated successfully!')
            },

            clearFilters() {
                this.tables.bills.filter = ''
                this.$refs.selectStatus.clear()
                this.$refs.selectVendors.clear()
                this.$refs.selectTags.clear()
            },

            openModal(modalName, row) {
                switch (modalName) {
                    case 'modal-common-adjust-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = this.tables.bills.userFields ? JSON.parse(JSON.stringify(this.tables.bills.userFields)) : JSON.parse(JSON.stringify(this.tables.bills.fields))

                        break
                    case 'modal-common-export-columns':
                        this.modals[modalName].active = 1

                        this.modals[modalName].fields = JSON.parse(JSON.stringify(this.tables.bills.fields.filter(e => !this.modals[modalName].ignores.includes(e.key))))

                        break
                }

                this.$nextTick(() => {
                    this.$bvModal.show(modalName)
                })
            },

            closeModal(modalName) {
                this.$bvModal.hide(modalName)
            },

            toggleBusy() {
                this.tables.bills.isBusy = !this.tables.bills.isBusy
            },

            getBills(silent) {
                this.tables.bills.ready = 0
                if (!silent) {
                    this.toggleBusy()
                }

                let url = 'api/purchasing/bills/getbills'
                axios.post(url, {
                    filters: this.filters.selected
                })
                .then((res) => {
                    this.tables.bills.items = res.data.bills

                    // if (!this.tables.bills.filteredItems.length) {
                        this.tables.bills.filteredItems = res.data.bills
                    // }

                    this.tables.bills.totalRows = this.tables.bills.items.length
                    this.tables.bills.ready = 1

                    if (!silent) {
                        this.toggleBusy()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            filterSelect(name, area) {
                this.filters.selected[area] = name
                this.getBills(1)
            },

            findCategoryName(id) {
                let index = this.findIndex(this.tables.bills.status, 'id', id)
                return this.tables.bills.status[index].label
            },

            getCategories() {
                let url = 'api/orders/bills/getcategoriesfilter'
                axios.get(url, {})
                .then((res) => {
                    this.tables.bills.status = res.data.categories
                }, () => {
                    this.has_error = true
                })
            },

            onFiltered(filteredItems) {
                this.tables.bills.totalRows = filteredItems.length
                this.tables.bills.currentPage = 1
                this.tables.bills.filteredItems = filteredItems
            },

            getVendorsFilter() {
                let url = 'api/purchasing/bills/getvendorsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.filters.vendors = res.data.vendors
                }, () => {
                    this.has_error = true
                })
            },

            getOrderTagsFilter() {
                let url = 'api/orders/sales-orders/getordertagsfilter'
                axios.get(url, {})
                .then((res) => {
                    this.filters.tags = res.data.tags
                }, () => {
                    this.has_error = true
                })
            },

            getColSaves() {
                let url = 'api/remembertable/getcolsaves/bills'
                axios.get(url, {})
                .then((res) => {
                    if (res.data.status == 'success') {
                        if (res.data.colSaves) {
                            if (res.data.colSaves.column_array.length == this.tables.bills.fields.length) {
                                this.tables.bills.userFields = res.data.colSaves.column_array
                            }
                        }

                        this.getBills()
                    }
                }, () => {
                    this.has_error = true
                })
            },

            saveColSaves(fields) {
                this.tables.bills.userFields = fields
                let url = 'api/remembertable/savecolsaves'
                axios.post(url, {
                    area: 'bills',
                    fields: fields.map(e => ({key:e.key, visible:parseInt(e.visible), label:e.label}))
                })
                .then((res) => {
                    this.forceRerender()
                }, () => {
                    this.has_error = true
                })
            },

            forceRerender() {
                this.tables.bills.ready = 0
                let tempFields = this.tables.bills.fields
                this.tables.bills.fields = []
                this.$nextTick(() => {
                    this.tables.bills.fields = tempFields
                    this.tables.bills.ready = 1
                })
            }
        },

    	computed: {
	    	sortOptions() {
                // Create an options list from our fields
                return this.tables.bills.fields
                    .filter(f => f.sortable)
                    .map(f => {
                        return { text: f.label, value: f.key }
                    })
            },

            pageTotals() {
                let totalRows = this.tables.bills.totalRows
                let currentPage = this.tables.bills.currentPage
                let perPage = this.tables.bills.perPage

                let from
                let to

                if (perPage > totalRows) {
                    from = 1
                    to = totalRows
                } else {
                    to = perPage * currentPage
                    from = to - perPage + 1
                }

                return 'Showing ' + from + ' to ' + to + ' of ' + this.tables.bills.totalRows + ' rows'
            },

            visibleFields() {
                let userFields = this.tables.bills.userFields
                if (userFields) {
                    let fields = this.tables.bills.fields

                    return fields.filter(field => {
                        let index = this.findIndex(userFields, 'key', field.key)
                        if (userFields[index].visible) {
                            return true
                        }
                    })
                } else {
                    return this.tables.bills.fields
                }
            }
	    },
	    mounted() {
            this.getColSaves()
            this.getVendorsFilter()
            this.getOrderTagsFilter()

            this.$root.$on('bv::modal::hidden', (bvEvent, modalId) => {
                switch (modalId) {
                    case 'modal-inventory-bills-edit-sales-order':
                        this.modals['edit-sales-order'].edit = []

                        break
                    case 'modal-inventory-bills-create-sales-order':
                        this.modals['create-sales-order'].create = {}

                        break
                    case 'modal-common-adjust-columns':
                        this.modals['modal-common-adjust-columns'].active = 0
                        this.modals['modal-common-adjust-columns'].fields = []

                        break
                    case 'modal-common-export-columns':
                        this.modals['modal-common-export-columns'].active = 0
                        this.modals['modal-common-export-columns'].fields = []

                        break
                }
            })

            // // pusher
            // Echo.channel('table-item-updated')
            //     .listen('TableItemUpdated', (e) => {
            //         this.getSalesOrders(1)
            // })
	    },

        created() {

        },

        watch: {

        }
    }
</script>
<style lang="scss">
    .buttons-create {

    }

    .vue-treeselect__control {
        // height: calc(1.5em + 0.5rem + 2px);
        // padding-top: 0.25rem;
        // padding-bottom: 0.25rem;
        // padding-left: 0.5rem;
        font-size: 0.875rem !important;

        .vue-treeselect__placeholder, .vue-treeselect__single-value {
            // line-height: 1.5
        }
    }

    .bills-table {
        height: 75vh;
        font-size: 9pt;

        .bills-thumbs {
            width: 80px;
            max-height: 80px;
        }

        .bills-table-style-actions {
            // width: 120px;

            .actions-icons {
                text-align: center;
            }
        }

        .bills-table-style-datetime {
            width: 110px;

            .actions-icons {
                text-align: center;
            }
        }

        .tag-badges {
            margin: 2px;
            padding: 5px;
        }
    }
</style>
